// @ts-nocheck
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

const pageTitleProps: TypographyPresentationProps = {
    color: "primary",
    variant: "h1",
    forwardAs: "h1",
    css: css`
        margin-bottom: 1em;
    `,
};

export const pageTitlePropsAlt: TypographyProps = {
    variant: "h1",
    as: "h1",
    css: css`
        margin-bottom: ${pxToRem(32)};
        &:last-child {
            margin-bottom: ${pxToRem(32)};
        }
    `,
};

export default pageTitleProps;
